import { ErrorHandler, NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { MaskPipe, NgxMaskModule } from 'ngx-mask';

import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxsModule } from '@ngxs/store';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';

import { TokenService } from '@services/token.service';
import { environment } from '@env/environment';
import { AppComponent } from './app.component';
import { LanguageService } from '@services/language.service';
import { AppRoutingModule } from './app.routing.module';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { PageErrorComponent } from './shared/components/page-error/page-error.component';
import { CustomDateByUtcPipe, CustomDateTimeByUtcPipe, IdentifierPipe, PaymentStateTranslatePipe } from '@shared/pipes-shared/pipes';
import { AlertModule } from '@shared/alert/alert.module';
import { FilingRestrictedModalModule } from '@shared/filing-restricted-modal';
import { CompanyProfileIncompleteModalModule } from '@shared/company-profile-incomplete-modal';
import { RequestLoaderModule } from '@shared/request-loader/request-loader.module';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AppLayoutModule } from './modules/app-layout/app-layout.module';
import { AppState } from './shared/state';
import { SharedState } from './shared/shared-state';

import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { ErrorHandlerService } from '@services/error-handler.service';
import { LoggerService } from '@services/logger.service';
import { ApiService } from '@services/api.service';
import { ApiErrorService } from '@services/api-error.service';
import { CacheService } from '@services/cache.service';
import { HTTPInterceptorsProviders } from '@interceptors/providers.interceptor';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';

import { AppService } from '@app/app.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CheckForUpdateService } from '@services/check-update-pwa.service';
import { CustomTooltipModule } from '@shared/tooltip/custom-tooltip.module';
import { DirectivesModule } from '@shared/directives/directives.module';
import { IndexedDbModule } from '@shared/indexed-db';
import { INDEXED_DB_CONFIG } from '@app/app-indexed-db.const';
import { AppMissingTranslationHandler } from './shared/handlers/app-missing-translation.handler';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}
@NgModule({
  imports: [
    BrowserModule,
    AppLayoutModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: AppMissingTranslationHandler,
      },
    }),
    // StoreModule.forRoot({ cbyState }),
    // StoreDevtoolsModule.instrument({
    //   maxAge: 25 //  Retains last 25 states
    // }),
    NgxMaskModule.forRoot({ validation: false }),
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    NgxsModule.forRoot([AppState, SharedState], {
      developmentMode: !environment.production,
      selectorOptions: {
        suppressErrors: false,
        injectContainerState: false,
      },
    }),
    NgxsLoggerPluginModule.forRoot({ disabled: environment.production }),
    AlertModule,
    FilingRestrictedModalModule,
    CompanyProfileIncompleteModalModule,
    RequestLoaderModule,
    TabsModule.forRoot(),
    NgSelectModule,
    HttpClientModule,

    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    CustomTooltipModule,
    DirectivesModule,
    IndexedDbModule,
    IndexedDbModule.forRoot(INDEXED_DB_CONFIG.DATABASE_CONFIG),
  ],
  exports: [],
  declarations: [AppComponent, NotFoundComponent, PageErrorComponent],

  providers: [
    LanguageService,
    TokenService,
    // { provide: REDUCERS_TOKEN, useValue: cbyState }
    DatePipe,
    CustomDateTimeByUtcPipe,
    CustomDateByUtcPipe,
    CurrencyPipe,
    MaskPipe,
    PaymentStateTranslatePipe,
    IdentifierPipe,
    { provide: NZ_I18N, useValue: en_US },
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    LoggerService,
    ErrorHandlerService,

    ApiService,
    ApiErrorService,
    CacheService,
    TokenService,
    CheckForUpdateService,
    HTTPInterceptorsProviders,

    JwtHelperService,
    { provide: JWT_OPTIONS, useValue: null },
    AppService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
